import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { DriverService } from 'src/app/shared/services/driver.service';
import { FactoryService } from 'src/app/shared/services/factory.service';
import { LoadingOrderService } from 'src/app/shared/services/loading-order.service';
import { ProductsService } from 'src/app/shared/services/products.service';
import { TransporterService } from 'src/app/shared/services/transporter.service';
import { UserService } from 'src/app/shared/services/user.service';
import { VehicleService } from 'src/app/shared/services/vehicle.service';
import { IVehicleTypes } from 'src/assets/static-data/enums/vehicle-types.enum';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import Swal from "sweetalert2";

@Component({
  selector: 'app-edit-loading-order',
  templateUrl: './edit-loading-order.component.html',
  styleUrl: './edit-loading-order.component.scss'
})
export class EditLoadingOrderComponent {
  loadingOrderForm: FormGroup;
  loadingOrderId: number;
  filteredCustomers :any; // Add logic to fetch customer data
  filteredProducts :any; // Add logic to fetch product data
  filteredfactories: any;
  filteredDrivers: any[] = [];
  filteredVehicles: any[];
  transporters = []; // Add logic to fetch transporter data
  factories: any[];
  vehicles = []; // Add logic to fetch vehicle data
  LoadingOrders: ILoadingOrder[];
  products: any[];
  customers: any[];
  drivers: any;
  locations: string[];
  customerLocations: any;
  @ViewChild('customerSelect') customerSelect: MatSelect;
  @ViewChild('productSelect') productSelect: MatSelect;
  @ViewChild('factorySelect') factorySelect: MatSelect;
  @ViewChild('inputTransporterRef', { static: true })
    inputTransporterElement!: ElementRef;
    @ViewChild('inputVehicleRef', { static: true })
    inputVehicleElement!: ElementRef;
    @ViewChild('inputDriverRef', { static: true })
    inputDriverElement!: ElementRef;
  customer: any;
  LoadingOrderStatus: any;
  data: any;
  orderNumber: any;
  vehicleType = Object.keys(IVehicleTypes).filter((key) => isNaN(Number(key))); // Only keys
  IVehicleTypes = IVehicleTypes; // Expose the enum to the template
  filteredTransporters: any[];
  @ViewChild('transporterSelect') transporterSelect: MatSelect; // Add a ViewChild for the transporter select
  @ViewChild('vehicleSelect') vehicleSelect: MatSelect; 
  @ViewChild('driverSelect') driverSelect: MatSelect; // Add a ViewChild for the transporter select
  transporterDrivers: any;
  basicDriverId:any;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private loadingOrderService: LoadingOrderService,
    private router: Router,
    private customerService: CustomerService,
    private UserService: UserService,
    private productService: ProductsService,
    private transporterService: TransporterService,
    private vehicleService: VehicleService,
    private factoryService: FactoryService,
    private driverService: DriverService,
  ) {
    
  }

  ngOnInit(): void {
    this.loadingOrderId = Number(this.route.snapshot.paramMap.get('id'));
    //console.log("loading Order Id", this.loadingOrderId);
    this.initForm();
    this.loadLoadingOrderData();

   //Disable the form fields
    // Object.keys(this.loadingOrderForm.controls).forEach(key => {
    //   this.loadingOrderForm.get(key)?.disable();
    // });

    this.loadingOrderForm.get('customerId')?.valueChanges.subscribe(value => {
      console.log('Customer ID changed:', value);
      
      this.customerService.getCustomerById(value).subscribe(response => {
        this.customer = response.data;
        const factoryDeliveryAddress = {
          id: -1, // ID to be sent to backend
          name: this.translateService.instant('ISFACTORYDELIVERY.TEXT') // Default name
          // Add any other necessary fields here
        };


        this.customerLocations = [
            factoryDeliveryAddress,
            ...this.customer.customerAddresses
          ];
      })
     
    });
    //Customer Data
    this.customerService.getAllCustomers().subscribe((response) => {
      this.customers = response.data;
      this.filteredCustomers = response.data; 
    });

    this.loadingOrderForm.get('searchCustomer')?.valueChanges.subscribe((searchText: string) => {
      this.filteredCustomers = this.customers.filter(customer =>
        customer.name.toLowerCase().includes(searchText.toLowerCase())
      );
      if (searchText && this.customerSelect) {
        this.customerSelect.open();
      }
    });

    this.loadingOrderForm.get('customerId')?.valueChanges.subscribe((value) => {
      if (value) {
        this.loadingOrderForm.get('searchCustomer')?.setValue(''); 
      }
    });

    //Product Data
    this.productService.getProducts().subscribe((response) => {
      this.products = response.data;
      this.filteredProducts = response.data; 
    });

    this.loadingOrderForm.get('searchProduct')?.valueChanges.subscribe((searchText: string) => {
      this.filteredProducts = this.products.filter(product =>
        product.name.toLowerCase().includes(searchText.toLowerCase())
      );
      if (searchText && this.productSelect) {
        this.productSelect.open();
      }
    });

    this.loadingOrderForm.get('itemId')?.valueChanges.subscribe((value) => {
      if (value) {
        this.loadingOrderForm.get('searchProduct')?.setValue(''); 
      }
    });

    //Transporter Data
    this.transporterService.getTransporters(true).subscribe((response) => {
      this.transporters = response.data;
      this.filteredTransporters = response.data;
    });

    this.loadingOrderForm.get('transporterId')?.valueChanges.subscribe(value => {
      
      this.vehicleService.getTransporterVehicles(value).subscribe(response => {
        this.vehicles = response.data;
        
      })
     
    });
    //Factory Data

    this.factoryService.getFactories().subscribe((response) => {
      this.factories = response.data;
      this.filteredfactories = response.data; 
    });

    this.loadingOrderForm.get('searchFactory')?.valueChanges.subscribe((searchText: string) => {
      this.filteredfactories = this.factories.filter(factory =>
        factory.name.toLowerCase().includes(searchText.toLowerCase())
      );
      if (searchText && this.factorySelect) {
        this.factorySelect.open();
      }
    });

    this.loadingOrderForm.get('factoryId')?.valueChanges.subscribe((value) => {
      if (value) {
        this.loadingOrderForm.get('searchFactory')?.setValue(''); 
      }
    });


    this.loadingOrderForm.get('transporterId')?.valueChanges.subscribe((value) => {
      this.transporterService.getTransporterDrivers(value).subscribe((response) => {
        this.transporterDrivers = response.data;
        this.filteredDrivers = response.data;
      });
    });

    this.loadingOrderForm.get('driverId')?.valueChanges.subscribe((value) => {
      if (value) {
        const selectedDriver = this.transporterDrivers.find(driver => driver.id == value);
        if (selectedDriver && selectedDriver.assignedVehicleId && !this.loadingOrderForm.get('vehicleId')?.value) {
          this.loadingOrderForm.get('vehicleId').setValue(selectedDriver.assignedVehicleId);
        } else {
          const vehicleId = this.loadingOrderForm.get('vehicleId')?.value;
          this.loadingOrderForm.get('vehicleId').setValue(vehicleId);
        }
      }
    });

    this.loadingOrderForm.get('vehicleId')?.valueChanges.subscribe((value) => {
      const selectedVehicle = this.filteredVehicles.find(vehicle => vehicle.id == value);
      if (this.loadingOrderForm.get('driverId')?.value == '') {
        if (selectedVehicle && selectedVehicle.drivers.length > 0) {
          this.loadingOrderForm.get('driverId').setValue(selectedVehicle.drivers[0].id);
        } else {
          this.loadingOrderForm.get('driverId').setValue(null);
        }
      }
    });
  }

  shouldDisable(driver:any){
    if(driver.isBusy && driver.id !=this.basicDriverId) return true;
    return false
  }

  initForm() {
    this.loadingOrderForm = this.fb.group({
      vehicleType:[''],
      factoryId: [''],
      customerId: [''],
      customerAddressId: [''],
      customerCountry: [''],
      searchCustomer: [''],
      searchProduct: [''],
      searchFactory: [''],
      itemId: [''],
      status: [''],
      customerRefNo: [''],
      numberOfRequests: [''],
      transporterId: [''],
      vehicleId: [''],
      driverId: [''],
      quantity: [''],
      transactionDate: [''],
      
    });
    //this.loadingOrderForm.get('customerId')?.disable();
    //this.loadingOrderForm.get('itemId')?.disable();
    this.loadingOrderForm.get('searchProduct')?.disable();
    this.loadingOrderForm.get('searchCustomer')?.disable();
  }

  //0:vehicleType,1:truck
  selectOption(event: MatSelectChange,type:number){
    if(event.value &&type==1){
      this.loadingOrderForm.get('driverId').setValue(this.drivers.filter(driver=>driver.assignedVehicleId==event.value)[0]?.id);
    }
  }
  loadLoadingOrderData() {
    this.loadingOrderService.getById(this.loadingOrderId).subscribe((response) => {
       this.data = response.data;
       this.orderNumber = this.data.orderNumber;
       console.log(this.data.customerAddressId);
       this.LoadingOrderStatus = this.data.status;
      this.loadingOrderForm.patchValue({
        factoryId: this.data.factoryId,
        customerId: this.data.customerId,
        itemId: this.data.itemId,
        transporterId: this.data.transporterId,
        customerCountry: this.data.customerCountry,
        customerRefNo: this.data.customerRefNo,
        numberOfRequests: this.data.numberOfRequests,
        vehicleId: this.data.vehicleId,
        quantity: this.data.quantity,
        driverId: this.data.driverId,
        customerAddressId: this.data.customerAddressId,
        status: this.data.status,
        transactionDate: this.data.transactionDate,
        vehicleType: this.data?.vehicleType,
      });

      this.basicDriverId=this.data.driverId;
    });
  }

  // onSubmit() {
  //   if (this.loadingOrderForm.valid) {
  //     const updatedLoadingOrder = this.loadingOrderForm.value;
  //     this.loadingOrderService.update(this.loadingOrderId, updatedLoadingOrder).subscribe(() => {
  //       Swal.fire({
  //         position: "center",
  //         icon: "success",
  //         title: this.translateService.instant("LOADING_ORDER_UPDATED_SUCCESSFULLY.TEXT"),
  //         timer: 1500,
  //       });
  //       this.router.navigate(['/transactions/loading-order']);
  //     });
  //   }
  // }

  send(){
    if (this.loadingOrderForm.valid) {
      //const updatedLoadingOrder = this.loadingOrderForm.value;
      const updatedLoadingOrder = this.loadingOrderForm.getRawValue();
      this.LoadingOrderStatus = 1;
      updatedLoadingOrder.status = this.LoadingOrderStatus;
      this.loadingOrderService.update(this.loadingOrderId, updatedLoadingOrder).subscribe(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: this.translateService.instant("LOADING_ORDER_UPDATED_SUCCESSFULLY.TEXT"),
          timer: 1500,
        });
        this.router.navigate(['/transactions/loading-order']);
      });
    }

  }

  saveAsDraft(){
    if (this.loadingOrderForm.valid) {
      //const updatedLoadingOrder = this.loadingOrderForm.value;
      const updatedLoadingOrder = this.loadingOrderForm.getRawValue();
      this.loadingOrderService.update(this.loadingOrderId, updatedLoadingOrder).subscribe(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: this.translateService.instant("LOADING_ORDER_UPDATED_SUCCESSFULLY.TEXT"),
          timer: 1500,
        });
        this.router.navigate(['/transactions/loading-order']);
      });
    }

  }

  filterDrivers(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    if (!this.transporterDrivers) {
      console.error('transporterDrivers is not initialized');
      return;
    }

    if (input) {
      console.log(input);
      this.driverSelect.open();
      // Combine firstName and lastName filters
      this.filteredDrivers = this.transporterDrivers.filter(
        (driver) =>
          driver.firstName.toLowerCase().includes(input.toLowerCase()) ||
          driver.lastName.toLowerCase().includes(input.toLowerCase())  ||
          driver.contactNumber.toLowerCase().includes(input.toLowerCase())  ||
          driver.residenceNumber.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      this.filteredDrivers = this.transporterDrivers; // Reset to full list
    }
  }

  filterVehicles(event: Event) {
    const input = (event.target as HTMLInputElement).value;

    if (input) {
      this.vehicleSelect.open();
      // Filter vehicles based on the search input
      this.vehicles = this.vehicles.filter((vehicle) =>
        vehicle.name.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      // Reset to the full list of vehicles if the search input is empty
      this.vehicles = this.filteredVehicles;
    }

    this.loadingOrderForm.get('vehicleId')?.valueChanges.subscribe((value) => {
      const selectedVehicle = this.vehicles.find(vehicle => vehicle.id == value);
      
      // Check if driverId is not already selected
      if (this.loadingOrderForm.get('driverId')?.value == '') {
        if (selectedVehicle && selectedVehicle.drivers.length > 0) {
          // Set driverId to the first driver's ID if no driver is currently selected
          this.loadingOrderForm.get('driverId').setValue(selectedVehicle.drivers[0].id);
        } else {
          // Set driverId to null if there are no drivers available
          this.loadingOrderForm.get('driverId').setValue(null);
        }
      }
    });
  }

  filterTransporters(event: Event) {
    const input = (event.target as HTMLInputElement).value;

    if (input) {
      this.transporterSelect.open();
      // Combine firstName and lastName filters
      this.filteredTransporters = this.transporters.filter((transporter) =>
        transporter.name.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      this.filteredTransporters = this.transporters; // Reset to full list
    }
  }

  clearSearchText() {
    this.inputTransporterElement.nativeElement.value = ''; // Clear the input field
     this.inputDriverElement.nativeElement.value = ''; 
    this.inputVehicleElement.nativeElement.value = ''; 
    this.filteredDrivers = this.transporterDrivers; 
    this.filteredTransporters = this.transporters; 
    this.filteredVehicles = this.vehicles; 
  }

  removeTransporterFilter(event: Event){
    event.stopPropagation(); 
    this.loadingOrderForm.get('transporterId').patchValue('');
    this.loadingOrderForm.get('driverId').patchValue('');
    this.loadingOrderForm.get('vehicleId').patchValue('');
  }

  removeDriverFilter(event: Event){
    event.stopPropagation(); // Prevent the dropdown from toggling
    this.loadingOrderForm.get('driverId').patchValue('');
  }
  removeVehicleFilter(event: Event){
    event.stopPropagation(); // Prevent the dropdown from toggling
    this.loadingOrderForm.get('vehicleId').patchValue('');
  }
}
